import { get } from 'lodash';

const styles = theme => ({
  card: {
    width: '19%',
    display: 'inline-block',
    margin: '0.5%',
    verticalAlign: 'top',
    minHeight: 260,
    backgroundColor: get(theme, 'color.uiBackground'),
  },
  title: {
    color: get(theme, 'color.bodyText'),
    fontFamily: get(theme, 'typography.bodyText'),
    fontSize: get(theme, 'fontSize.title'),
  },
  titleText: {
    paddingLeft: 10,
  },
  titleIcon: {
    verticalAlign: 'middle',
    '& svg': {
      fontSize: get(theme, 'fontSize.title'),
    },
  },
  divider: {
    marginTop: 4,
    backgroundColor: get(theme, 'color.borderColor'),
  },
  description: {
    marginBottom: 12,
    marginTop: 12,
    color: get(theme, 'color.bodyText'),
    fontSize: get(theme, 'fontSize.bodyText'),
    fontFamily: get(theme, 'typography.bodyText'),
    '& svg': {
      verticalAlign: 'text-top',
    },
  },
  lastSync: {
    color: get(theme, 'color.bodyText'),
    fontSize: get(theme, 'fontSize.bodyText'),
    fontFamily: get(theme, 'typography.bodyText'),
    marginTop: 5,
    '& h4': {
      marginTop: 10,
      marginBottom: 5,
    },
  },
  lastSyncDescription: {
    color: get(theme, 'color.smallText'),
    fontSize: get(theme, 'fontSize.smallText'),
    fontFamily: get(theme, 'typography.smallText'),
  },
  errorIconRoot: {
    color: get(theme, 'color.error'),
    width: 16,
    height: 16,
  },
  successIconRoot: {
    color: get(theme, 'color.success'),
    width: 16,
    height: 16,
  },
  iconStatus: {
    paddingRight: 5,
    verticalAlign: 'middle',
  },
  iconStatusText: {
    verticalAlign: 'middle',
  },
  publishText: {
    fontSize: get(theme, 'fontSize.smallText'),
    marginRight: 15,
  },
  helpIcon: {
    fontSize: 12,
    margin: get(theme, 'margin.m4'),
    verticalAlign: 'inherit',
    cursor: 'pointer',
    color: `${get(theme, 'color.link')} !important`,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/ApiProxy/Details/ApiCard/styles.js